import { Component, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { TextField } from '@sitecore-jss/sitecore-jss-angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { RichTextWrapperComponent } from '../rich-text-wrapper/rich-text-wrapper.component';

@Component({
  selector: 'wl-checklist-item',
  templateUrl: './checklist-item.component.html',
  styleUrls: [
    './checklist-item.component.ed.scss',
    './checklist-item.component.essent.scss',
  ],
  standalone: true,
  imports: [FaIconComponent, AutomationIdDirective, RichTextWrapperComponent],
})
export class ChecklistItemComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isChecked?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() titleAutomationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() description?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() descriptionAutomationId?: string;
}
